import { Translation } from "../hooks/useTranslations";

const it: Translation = {
  drivers: {
    edit: "Modifica conducente",
    new: "Nuovo conducente",
    singular: "Conducente",
    plural: "Conducenti",
    delete: "Elimina conducente",

    questions: {
      delete: "Vuoi davvero eliminare questo conducente?",
    },
  },

  subsidiaries: {
    delete: "Elimina consociata",
    edit: "Modifica consociata",
    new: "Nuova consociata",
    singular: "Consociata",
    plural: "Consociate",
    versions: "Versioni consociata",

    questions: {
      delete: "Vuoi davvero eliminare questa consociata?",
    },

    errors: {
      notMatchingSubsidiaryFound: "Nessuna consociata corrispondente trovata.",
      nameAlreadyExists: "Nome della consociata già utilizzato",
      countryISOCodeAlreadyExists: "Il codice ISO del paese specificato è già definito per un'altra consociata.",
      inUseByCars: "La consociata è ancora utilizzata da auto e non può essere eliminata.",
      inUseByCarOrders: "La consociata è ancora utilizzata da un acquisto auto e non può essere eliminata.",
      missingVatServiceCode: "Codice IVA servizi della consociata mancante",
      missingVatDeductionCode: "Codice detrazione IVA della consociata mancante",
      missingCountryIsoCode: "Codice ISO paese della consociata mancante",
      missingSemiramisOrganizationCode: "Codice organizzazione Semiramis della consociata mancante",
    },
  },

  manufacturers: {
    delete: "Elimina produttore",
    edit: "Modifica produttore",
    new: "Nuovo produttore",
    singular: "Produttore",
    plural: "Produttori",
    versions: "Versioni produttore",

    questions: {
      delete: "Vuoi davvero eliminare questo produttore?",
    },

    errors: {
      nameAlreadyUsed: "Esiste già un produttore con lo stesso nome.",
      inUseByCars: "Il produttore è ancora utilizzato da auto e non può essere eliminato.",
      inUseByCarOrders: "Il produttore è ancora utilizzato da un acquisto auto e non può essere eliminato.",
    },
  },

  cars: {
    all: "Tutte le auto",
    delete: "Elimina auto",
    edit: "Modifica auto",
    new: "Nuova auto",
    singular: "Auto",
    plural: "Auto",
    versions: "Versioni auto",

    questions: {
      delete: "Vuoi davvero eliminare questa auto?",
    },

    errors: {
      vinAlreadyUsed: "Esiste già un'auto con il numero di telaio specificato.",
      carReadNotAllowed: "Lettura auto non consentita",
    },
  },

  suppliers: {
    delete: "Elimina fornitore",
    edit: "Modifica fornitore",
    new: "Nuovo fornitore",
    singular: "Fornitore",
    plural: "Fornitori",
    versions: "Versioni fornitore",

    questions: {
      delete: "Vuoi davvero eliminare questo fornitore?",
    },

    errors: {
      nameAlreadyUsed: "Esiste già un fornitore con lo stesso nome.",
      inUseByCarOrders: "Il fornitore è ancora utilizzato da acquisti auto e non può essere eliminato.",
    },
  },

  carOrders: {
    all: "Tutti gli acquisti auto",
    delete: "Elimina acquisto auto",
    edit: "Modifica acquisto auto",
    new: "Nuovo acquisto auto",
    singular: "Acquisto auto",
    plural: "Acquisti auto",
    versions: "Versioni acquisto auto",

    questions: {
      delete: "Vuoi davvero eliminare questo acquisto auto?",
      deleteLinkedPlanning:
        'Questo acquisto auto è collegato a una pianificazione auto. Il suo stato verrà ripristinato su "Da ordinare".',
    },

    errors: {
      carOrderDateAfterSoldDate: "La data di acquisto dell'auto non può essere dopo la data di vendita.",
    },
  },

  carPlates: {
    delete: "Elimina targa",
    edit: "Modifica targa",
    new: "Nuova targa",
    singular: "Targa",
    plural: "Targhe",
    versions: "Versioni targa",

    questions: {
      delete: "Vuoi davvero eliminare questa targa?",
    },

    errors: {
      plateOverlapPeriodSub: "La targa è già utilizzata da un'altra auto nella stessa consociata.",
      plateOverlapPeriodCar: "Il periodo specificato si sovrappone con un altra targa.",
      carPlateOutOfSubsidiaryPeriod: "Il periodo della targa non rientra nel periodo della consociata.",
    },
  },

  carDrivers: {
    delete: "Elimina conducente auto",
    edit: "Modifica conducente auto",
    new: "Nuovo conducente auto",
    singular: "Conducente auto",
    plural: "Conducenti auto",
    versions: "Versioni conducente auto",
    sendMileageEmail: "Invia email chilometraggio al nuovo conducente",
    mileageEmailFirstAssignment: "L'email non può essere inviata: è il primo conducente di quest'auto.",
    mileageEmailNotificationsDisabled: (flag: string) =>
      `L'email non può essere inviata: il conducente ha il flag "${flag}" attivo.`,
    mileageEmailNoEmail: "L'email non può essere inviata: questo conducente non ha un indirizzo email.",

    questions: {
      delete: "Vuoi davvero eliminare questo conducente auto?",
    },

    errors: {
      overlapsPeriod: "Il periodo specificato si sovrappone con un altro conducente auto.",
      overlapsPeriodPool: "Il periodo specificato si sovrappone con un altro del parco auto.",
      carDriverOutOfSubsidiaryPeriod: "Il periodo del conducente non rientra nel periodo della consociata.",
      delegationLanguageNotFound: "La lingua selezionata non è disponibile per le deleghe.",
      delegationSubsidiaryNotConfigured:
        "I dati della delega non sono configurati per il codice organizzazione Semiramis della consociata.",
    },
  },

  carLeasings: {
    delete: "Elimina leasing auto",
    edit: "Modifica leasing auto",
    conclude: "Concludi leasing auto",
    new: "Nuovo leasing auto",
    singular: "Leasing auto",
    plural: "Leasing auto",
    versions: "Versioni leasing auto",

    questions: {
      delete: "Vuoi davvero eliminare questo leasing auto?",
      conclude: "Vuoi davvero concludere questo leasing auto?",
    },

    errors: {
      alreadyHasLeasing: "Per l'auto specificata è già definito un leasing.",
      expirationDateCantMatchContractDate: "La data di scadenza non può coincidere con la data del contratto",
      expirationDateCantBeBeforeContractDate: "La data di scadenza non può precedere la data del contratto",
    },
  },

  mileages: {
    delete: "Elimina percorrenza",
    edit: "Modifica percorrenza",
    new: "Nuova percorrenza",
    singular: "Percorrenza",
    plural: "Percorrenze",
    versions: "Versioni percorrenza",
    sendReminder: "Invia promemoria chilometraggio",
    sendReminders: "Invia promemoria",

    questions: {
      delete: "Vuoi davvero eliminare questa percorrenza?",
      sendReminder:
        "Vuoi inviare al conducente attuale un'email che gli ricorda di inserire il chilometraggio aggiornato di quest'auto?",
    },

    reminderDialog: {
      recipient: "Destinatario",
      lastReminder: "Ultimo promemoria chilometraggio inviato al conducente",
      noReminderSent: "Nessun promemoria inviato",
      automaticReminderRule:
        "Fleet Manager invia automaticamente un promemoria chilometraggio ai conducenti delle auto senza un chilometraggio negli ultimi 3 mesi, ma esclude i conducenti che ne hanno già ricevuto uno negli ultimi 3 giorni. Se aggiorni la data dell'ultimo promemoria, questa email conta come ultimo promemoria inviato e il conducente non riceverà il promemoria automatico nei prossimi 3 giorni, anche nel caso in cui in questo periodo scadessero i 3 mesi.",
      updateLastReminder: "Aggiorna data ultimo promemoria",
      driverNotificationsDisabled: (flag) =>
        `L'email non può essere inviata: il conducente ha il flag "${flag}" attivo.`,
      driverNoEmail: "L'email non può essere inviata: il conducente non ha un indirizzo email.",
    },

    remindersDialog: {
      question:
        "Vuoi inviare ai conducenti attuali delle auto attive un'email che ricorda di inserire il chilometraggio aggiornato della propria auto?",
      recipients: "Destinatari",
      allDrivers: "Tutti i conducenti",
      onlyOverdue: "Solo chilometraggio scaduto (oltre 3 mesi)",
      allSubsidiaries: "Tutte le consociate",
      summary: (drivers, emails) =>
        `Conducenti da notificare: ${drivers} (email da inviare: ${emails}, una per ogni auto).`,
      excluded: (excluded) =>
        `Conducenti esclusi perché hanno le notifiche disattivate o non hanno un indirizzo email: ${excluded}.`,
      noRecipients: "Nessun conducente da notificare.",
      onlyOverdueInfo: (option) =>
        `Con "${option}" vengono notificati solo i conducenti delle auto il cui ultimo chilometraggio è più vecchio di 3 mesi o che non hanno mai avuto un chilometraggio.`,
      updateLastReminderInfo: (switchLabel) =>
        `Fleet Manager invia anche un promemoria automatico ai conducenti con chilometraggio scaduto, ma esclude chi ne ha ricevuto uno negli ultimi 3 giorni. Attivando "${switchLabel}", la data dell'ultimo promemoria dei conducenti notificati diventa oggi: per i prossimi 3 giorni non riceveranno il promemoria automatico, anche nel caso in cui in questo periodo scadessero i 3 mesi.`,
      backgroundInfo:
        "L'invio dei promemoria prosegue in background: puoi chiudere questa finestra e continuare a lavorare. Al termine riceverai un avviso.",
      alreadySending:
        "È già in corso un invio dei promemoria chilometraggio: potrai avviarne un altro quando sarà terminato.",
      sent: "Promemoria chilometraggio inviati.",
    },

    notNotifiedDialog: {
      title: "Promemoria chilometraggio non inviati",
      text: "Non è stato possibile inviare il promemoria chilometraggio ai seguenti conducenti:",
    },

    errors: {
      mileageWithThisDateAlreadyExists: "Per la data selezionata è già stato registrato lo stesso chilometraggio.",
      distanceLowerPrevRecord: "La percorrenza inserita è inferiore al record precedente.",
      distanceHigherNextRecord: "La percorrenza è superiore al record successivo.",
      mileageOutOfSubsidiaryPeriod: "La data della percorrenza non rientra nel periodo della consociata.",
      mileageOutOfCarDriverPeriod: "La data della percorrenza è fuori dal periodo in cui la macchina ti è assegnata.",
      mileageMustBeBetween: (prevDate, prevDistance, nextDate, nextDistance) =>
        `Per la data selezionata, la distanza deve essere compresa tra ${prevDistance} (il ${prevDate}) e ${nextDistance} (il ${nextDate}).`,
      mileageMustBeGreater: (distance, date) =>
        `Per la data selezionata, la distanza deve essere maggiore di ${distance} (il ${date}).`,
      mileageMustBeLower: (distance, date) =>
        `Per la data selezionata, la distanza deve essere inferiore a ${distance} (il ${date}).`,
      reminderMissingCurrentDriver: "L'email non può essere inviata: l'auto non ha un conducente attuale.",
      reminderDriverMissingEmail: "L'email non può essere inviata: il conducente non ha un indirizzo email.",
      reminderDriverNotificationsDisabled:
        "L'email non può essere inviata: il conducente ha le notifiche disabilitate.",
      reminderSubsidiaryNotAllowed: "Non hai accesso alla consociata selezionata.",
    },
  },

  defaultTasks: {
    new: "Nuova attività predefinita",
    edit: "Modifica attività predefinita",
    delete: "Elimina attività predefinita",
    singular: "Attività predefinita",
    plural: "Attività predefinite",

    questions: {
      delete: "Vuoi davvero eliminare questa attività predefinita?",
    },
  },

  customTasks: {
    set: "Imposta attività personalizzata",
    create: "Crea attività personalizzata",
    edit: "Modifica attività personalizzata",
    singular: "Attività personalizzata",
    plural: "Attività personalizzate",

    questions: {
      customize: "La consociata utilizza attualmente le attività predefinite. Vuoi personalizzarle?",
    },

    errors: {
      taskAlreadySelected: "L'attività è già stata selezionata.",
    },
  },

  tasks: {
    delete: "Elimina attività",
    rename: "Rinomina attività",
    edit: "Modifica attività",
    new: "Nuova attività",
    singular: "Attività",
    plural: "Attività",
    versions: "Versioni attività",

    questions: {
      delete: "Vuoi davvero eliminare questa attività?",
    },

    errors: {
      taskNameAlreadyExists: "Esiste già un'attività predefinita con lo stesso nome.",
      inUseByCustomTasks:
        "L'attività predefinita è ancora utilizzata da un'attività personalizzata e non può essere eliminata.",
    },
  },

  tasksCategories: {
    delete: "Elimina categoria attività",
    plural: "Categorie attività",

    questions: {
      deleteSubsidiaryCustomTasks:
        "Vuoi davvero eliminare questa categoria personalizzata e associare le attività predefinite?",
    },
  },

  carTasks: {
    delete: "Elimina attività auto",
    edit: "Modifica attività auto",
    new: "Nuova attività auto",
    singular: "Attività auto",
    plural: "Attività auto",

    questions: {
      delete: "Vuoi davvero eliminare questa attività?",
      deleteWithWorkflow:
        "Questa attività è associata a un workflow. Se procedi, sia l'attività che il workflow correlato verranno eliminati. Vuoi continuare?",
    },

    errors: {
      inUseByWorkflows: "Il task del veicolo è ancora utilizzata da un flusso di lavoro e non può essere eliminata.",
    },
  },

  leasingCompanies: {
    delete: "Elimina società di leasing",
    edit: "Modifica società di leasing",
    new: "Nuova società di leasing",
    singular: "Società di leasing",
    plural: "Società di leasing",
    versions: "Versioni società di leasing",

    questions: {
      delete: "Vuoi davvero eliminare questa società di leasing?",
    },

    errors: {
      nameAlreadyExists: "Esiste già una società di leasing con lo stesso nome.",
      inUseByCarLeasings: "La società di leasing è ancora utilizzata da un leasing auto e non può essere eliminata.",
    },
  },

  plateNumbers: {
    singular: "Targa",
  },

  highwayPasses: {
    delete: "Elimina telepass",
    edit: "Modifica telepass",
    new: "Nuovo telepass",
    singular: "Telepass",
    plural: "Telepass",
    versions: "Versioni telepass",

    questions: {
      delete: "Vuoi davvero eliminare questo telepass?",
    },

    errors: {
      highwayPassOverlaps:
        "Un telepass con lo stesso numero e per il periodo specificato è già utilizzato da un'altra auto.",
      highwayPassOutOfSubsidiaryPeriod: "Il periodo del telepass non rientra nel periodo della consociata.",
    },
  },

  costTypeCategories: {
    delete: "Elimina categoria tipo costo",
    edit: "Modifica categoria tipo costo",
    new: "Nuova categoria tipo costo",
    singular: "Categoria tipo costo",
    plural: "Categorie tipo costo",
    versions: "Versioni categoria tipo costo",

    questions: {
      delete: "Vuoi davvero eliminare questa categoria tipo costo?",
    },

    errors: {
      isUsedByCostType: "La categoria tipo costo è ancora utilizzata da un tipo costo e non può essere eliminata.",
      nameAlreadyUsed: "Una categoria tipo costo con lo stesso nome è già definita.",
    },
  },

  costTypes: {
    delete: "Elimina tipo costo",
    edit: "Modifica tipo costo",
    new: "Nuovo tipo costo",
    singular: "Tipo costo",
    plural: "Tipi costo",
    versions: "Versioni tipo costo",

    questions: {
      delete: "Vuoi davvero eliminare questo tipo costo?",
    },

    errors: {
      isUsedByCosts: "Il tipo costo è ancora utilizzato da un costo e non può essere eliminato.",
      nameAlreadyUsed: "Esiste già un tipo costo con questo nome.",
    },
  },

  costs: {
    delete: "Elimina costo",
    edit: "Modifica costo",
    new: "Nuovo costo",
    singular: "Costo",
    plural: "Costi",
    versions: "Versioni costo",

    questions: {
      delete: "Vuoi davvero eliminare questo costo?",
    },

    errors: {
      costOutOfSubsidiaryPeriod: "La data del costo non rientra nel periodo della consociata.",
      missingCurrency: (currency: string) => `Impossibile convertire il costo in EUR: valuta ${currency} non trovata.`,
    },
  },

  maintenanceTypes: {
    delete: "Elimina tipo manutenzione",
    edit: "Modifica tipo manutenzione",
    new: "Nuovo tipo manutenzione",
    singular: "Tipo manutenzione",
    plural: "Tipi manutenzione",

    questions: {
      delete: "Vuoi davvero eliminare questo tipo manutenzione?",
    },

    errors: {
      isUsedByMaintenance: "Il tipo manutenzione è ancora utilizzato da una manutenzione e non può essere eliminato.",
      nameAlreadyUsed: "Esiste già un tipo manutenzione con lo stesso nome.",
    },
  },

  maintenance: {
    delete: "Elimina manutenzione",
    edit: "Modifica manutenzione",
    new: "Nuova manutenzione",
    singular: "Manutenzione",
    plural: "Manutenzioni",

    questions: {
      delete: "Vuoi davvero eliminare questa manutenzione?",
    },
  },

  costsImport: {
    delete: "Elimina importazione costi",
    changeCarAssignment: "Cambia veicolo associato",
    changeCarAssignmentDisclaimer: (plate: string, date: string) =>
      `Il costo è stato fatturato alla targa ${plate} con data ${date}. Prima di apportare modifiche manuali, verifica i dati aggiornati in Fleet Management per assicurarti che questa correzione sia davvero necessaria.`,
    noDriverCoversDate: "Nessuna delle assegnazioni elencate sopra copre la data di questo costo.",
    missingAssignmentCostCenter: (name: string) =>
      `${name} copre la data di questo costo ma non ha un centro di costo definito.`,
    carForcedManually: (date: string) => `Il veicolo è stato assegnato manualmente il ${date}.`,
    assignmentForcedManually: (date: string) => `L'assegnazione del conducente è stata forzata manualmente il ${date}.`,
    carForcedFromTo: (fromPlate: string, toPlate: string, name: string, date: string) =>
      `L'assegnazione del veicolo è stata modificata da ${fromPlate} a ${toPlate} da ${name} il ${date}.`,
    removeForcedCar: "Rimuovi forzature",
    costWillBeAssignedTo: (name: string) => `Questo costo verrà assegnato a ${name}.`,
    forceThisDriver: "Forza questo conducente",
    removeAssignment: "Rimuovi assegnazione",
    forcedAssignmentDoesNotCoverDate: "Questa assegnazione non copre la data di questo costo.",
    excludedFromExport: (plate: string) =>
      `Per ${plate} questa riga non viene esportata nei costi: vengono esportati solo i veicoli pkw, pkw-superior e lkw.`,

    questions: {
      deleteImport: "Vuoi davvero eliminare questa importazione di costi?",
      importInCosts: "Vuoi davvero importare queste righe nei costi?",
      forceDriver: (name: string) =>
        `Vuoi davvero forzare l'assegnazione di questo costo a ${name}? Questo sovrascrive l'assegnazione automatica basata sulla data.`,
    },

    dkv: {
      noCarFound: (plate: string, date: string) => `Per la targa ${plate} nessun veicolo copre il costo del ${date}`,
      noDriverFound: (plate: string, date: string) =>
        `Per il veicolo ${plate} nessuna assegnazione copre il costo del ${date}`,
      noSubsidiaryVatCodeFound: (productCode: string) => `Per ${productCode} nessun codice IVA trovato`,
      noCostTypeFound: (productCode: string, category?: string) =>
        `Per ${productCode}${category ? `/${category}` : ""} nessun tipo di costo trovato`,
      noCostCenterFound: (name: string, date: string) =>
        `Per ${name} nessun centro di costo copre il costo del ${date}`,
      noUserCostCenterFound: (plate: string, date: string) =>
        `Per il veicolo ${plate} nessun centro di costo utente copre il costo del ${date}`,

      errors: {
        columnTargaVeicolo: "Colonna 'Targa veicolo' non trovata",
        columnDataFattura: "Colonna 'Data della fattura' non trovata",
        columnOraTransazione: "Colonna 'Ora transazione' non trovata",
        columnValoreBaseNetto: "Colonna 'Valore base netto' non trovata",
        columnValoreBaseLordo: "Colonna 'Valore base lordo' non trovata",
        columnCodiceMerce: "Colonna 'Codice merce' non trovata",
        columnGruppoProdotti: "Colonna 'Gruppo di prodotti' non trovata",
        columnTipoMerce: "Colonna 'Tipo di merce' non trovata",
        columnPaesePedaggio: "Colonna 'Paese di pedaggio' non trovata",
        columnIva: "Colonna 'IVA' non trovata",
        columnScontoNetto: "Colonna 'Sconto netto' non trovata",
        columnScontoLordo: "Colonna 'Sconto lordo' non trovata",
        columnServiceFeeNetto: "Colonna 'Service fee netto' non trovata",
        columnQuantita: "Colonna 'Quantità' non trovata",
        columnUnita: "Colonna 'Unità' non trovata",
      },
    },

    dkvTolls: {
      errors: {
        columnDataFattura: "Colonna 'Data della fattura' non trovata",
        columnTargaVeicolo: "Colonna 'Targa veicolo' non trovata",
        columnOraUscita: "Colonna 'Ora uscita' non trovata",
        columnCodiceMerce: "Colonna 'Codice merce' non trovata",
        columnValutaServizio: "Colonna 'Valuta del servizio' non trovata",
        columnIva: "Colonna 'IVA' non trovata",
        columnValoreBaseNetto: "Colonna 'Valore base netto' non trovata",
        columnPaesePedaggio: "Colonna 'Paese di pedaggio' non trovata",
      },
    },
  },

  dueDateTypes: {
    delete: "Elimina tipo scadenza",
    edit: "Modifica tipo scadenza",
    new: "Nuovo tipo scadenza",
    singular: "Tipo scadenza",
    plural: "Tipi scadenza",
    versions: "Versioni tipo scadenza",

    questions: {
      delete: "Vuoi davvero eliminare questo tipo scadenza?",
    },

    errors: {
      isUsedByDueDates: "Il tipo scadenza è ancora utilizzato da una scadenza e non può essere eliminato.",
      nameAlreadyUsed: "Esiste già un tipo scadenza con lo stesso nome.",
    },
  },

  dueDates: {
    all: "Tutte le scadenze",
    delete: "Elimina scadenza",
    edit: "Modifica scadenza",
    new: "Nuova scadenza",
    singular: "Scadenza",
    plural: "Scadenze",
    versions: "Versioni scadenza",
    renewPlural: "Rinnova scadenze",
    renewSingular: "Rinnova scadenza",
    renewSelected: "Rinnova scadenze selezionate",
    setSettledSelected: "Segna come saldate le scadenze selezionate",

    questions: {
      delete: "Vuoi davvero eliminare questa scadenza?",
      setSettled: "Vuoi davvero segnare come saldate le scadenze selezionate?",
    },

    errors: {
      dueDateOutOfSubsidiaryPeriod: "La data della scadenza non rientra nel periodo della consociata.",
    },
  },

  documents: {
    add: "Aggiungi documento",
    all: "Tutti i documenti",
    alreadyPresent: "Documento già presente.",
    plural: "Documenti",
    delete: "Elimina documento",
    search: "Cerca documenti",

    questions: {
      delete: "Vuoi davvero eliminare questo documento?",
      overwrite: "Vuoi sovrascrivere il documento già presente?",
    },

    errors: {
      notFound: "Il documento non è stato trovato",
    },
  },

  users: {
    all: "Tutti gli utenti",
    delete: "Elimina utente",
    edit: "Modifica utente",
    new: "Nuovo utente",
    singular: "Utente",
    plural: "Utenti",

    questions: {
      delete: "Vuoi davvero eliminare questo utente?",
    },

    errors: {
      noMatchingUserFound: "Nessun utente corrispondente trovato.",
      rothoblaasUserWithEmailNotFound: "Non è stato trovato alcun utente Rothoblaas con l'indirizzo email specificato.",
      usersWithEmailAlreadyExists: "Esiste già un utente con l'email specificata.",
      inUseByCarTasks: "L'utente è ancora utilizzato da un'attività auto e non può essere eliminato.",
      inUseByCarOrders: "L'utente è ancora utilizzato da un acquisto auto e non può essere eliminato.",
      inUseByCarDrivers: "L'utente è ancora utilizzato come conducente e non può essere eliminato.",
      usersWithEmailNotFound: "Non è stato trovato nessun utente con l'email specificata.",
      invalidEmailDomain: "Il dominio dell'email non è valido per gli utenti rothoblaas.",
      userSubsidiaryAlreadyExists: "L'utente è già assegnato alla consociata specificata.",
      userInUseAsManager: "L'utente è ancora utilizzato come manager e non può essere eliminato.",
    },
  },

  claims: {
    all: "Tutti i sinistri",
    delete: "Elimina sinistro",
    edit: "Modifica sinistro",
    new: "Nuovo sinistro",
    singular: "Sinistro",
    plural: "Sinistri",
    incidentDate: "Data del sinistro",
    openingDate: "Data di apertura",
    closingDate: "Data di chiusura",
    damageValue: "Valore del danno",
    settledAmount: "Importo liquidato",

    questions: {
      delete: "Vuoi davvero eliminare questo sinistro?",
      switchDriver: (selectedDriver: string, currentDriver: string) =>
        `Il driver selezionato è ${selectedDriver}, ma quello attualmente assegnato è ${currentDriver}.<br /> Vuoi assegnare questo reclamo a ${currentDriver}?`,
      switchSubsidiary: (selectedSubsidiary: string, currentSubsidiary: string) =>
        `La filiale selezionata è ${selectedSubsidiary}, ma quella attualmente assegnata è ${currentSubsidiary}.<br /> Vuoi assegnare questo sinistro a ${currentSubsidiary}?`,
    },
  },

  fines: {
    delete: "Elimina multa",
    edit: "Modifica multa",
    new: "Nuova multa",
    singular: "Multa",
    plural: "Multe",
    verbalNumber: "Numero verbale",
    violationDate: "Data violazione",
    communicationDate: "Data di comunicazione",
    firstNotificationDate: "Data prima notifica",
    amount: "Importo",
    points: "Punti",
    accountant: "Contabile",
    hrReferent: "Referente HR",
    notifyDriver: "Notifica driver",
    archive: "Archivia",
    notifications: "Notifiche",
    sentBy: "Inviato da",
    sentAt: "Inviato il",
    notifyDialog: {
      recipient: "Destinatario",
      attachments: "Allegati",
      noAttachments: "Seleziona almeno un documento da inviare.",
      addDocuments: "Aggiungi documenti",
      dropDocumentsHint: "Puoi anche trascinare i file sulla tabella",
      attachmentsHint: "I documenti aggiunti qui vengono salvati anche nei documenti della multa.",
      alreadyNotified: (name: string, date: string) => `Già notificata da ${name} il ${date}.`,
      driverNotificationsDisabled: (flag: string) =>
        `L'email non può essere inviata: il conducente ha il flag "${flag}" attivo.`,
      driverNoEmail: "L'email non può essere inviata: il conducente non ha un indirizzo email.",
      userNotificationsDisabled: (flag: string) =>
        `Questo utente ha il flag "${flag}" attivo e non può ricevere la copia.`,
      userNoEmail: "Questo utente non ha un indirizzo email e non può ricevere la copia.",
    },
    errors: {
      notifyArchived: "Una multa archiviata non può essere notificata.",
      alreadyArchived: "La multa è già archiviata.",
      driverMissingEmail: "L'email non può essere inviata: il conducente non ha un indirizzo email.",
      driverNotificationsDisabled: "L'email non può essere inviata: il conducente ha le notifiche disabilitate.",
    },
    statuses: {
      new: "Nuova",
      notified: "Notificata",
      archived: "Archiviata",
    },
    questions: {
      delete: "Vuoi davvero eliminare questa multa?",
      archive: "Vuoi davvero archiviare questa multa?",
    },
  },

  claimTypes: {
    all: "Tutti i tipi di sinistro",
    delete: "Elimina tipo di sinistro",
    edit: "Modifica tipo di sinistro",
    new: "Nuovo tipo di sinistro",
    singular: "Tipo di sinistro",
    plural: "Tipi di sinistro",

    questions: {
      delete: "Vuoi davvero eliminare questo tipo di sinistro?",
    },

    errors: {
      nameAlreadyUsed: "Esiste già un tipo di sinistro con questo nome.",
      inUseByClaims: "Il tipo di sinistro è ancora in uso nelle pratiche e non può essere eliminato.",
    },
  },

  clients: {
    all: "Tutti i clients",
    plural: "Clients",
    createNew: "Crea nuovo client",
    delete: "Elimina client",
    search: "Cerca clients",

    questions: {
      delete: "Vuoi davvero eliminare questo client?",
    },

    errors: {
      notFound: "Client non trovato.",
      missingName: "Nome client mancante.",
      insertNotAllowed: "Non sei autorizzato a inserire un nuovo client.",
      readNotAllowed: "Non sei autorizzato a leggere questo client.",
      updateNotAllowed: "Non sei autorizzato ad aggiornare questo client.",
      deleteNotAllowed: "Non sei autorizzato a eliminare questo client.",
    },
  },

  subsidiaryVatCodes: {
    delete: "Elimina codice IVA consociata",
    edit: "Modifica codice IVA consociata",
    new: "Nuovo codice IVA consociata",
    singular: "Codice IVA consociata",
    plural: "Codici IVA consociata",
    versions: "Versioni codice IVA consociata",

    questions: {
      delete: "Vuoi davvero eliminare questo codice IVA consociata?",
    },
  },

  roles: {
    delete: "Elimina ruolo",
    edit: "Modifica ruolo",
    new: "Nuovo ruolo",
    singular: "Ruolo",
    plural: "Ruoli",

    questions: {
      delete: "Vuoi davvero eliminare questo ruolo?",
    },
  },

  permissions: {
    plural: "Permessi",
  },

  secrets: {
    plural: "Segreti",

    errors: {
      missingName: "Nome del segreto mancante.",
      missingValue: "Valore del segreto mancante.",
    },
  },

  carPoolCostCenters: {
    delete: "Elimina centro di costo del parco auto",
    edit: "Modifica centro di costo del parco auto",
    new: "Nuovo centro di costo del parco auto",
    singular: "Centro di costo del parco auto",
    plural: "Centri di costo del parco auto",

    questions: {
      delete: "Vuoi davvero eliminare questo centro di costo del parco auto?",
    },

    errors: {
      carPoolOverlapPeriod: "Il parco auto ha già un centro di costo in questo periodo",
    },
  },

  otherCarAssignments: {
    delete: "Elimina altra assegnazione auto",
    edit: "Modifica altra assegnazione auto",
    new: "Nuova altra assegnazione auto",
    singular: "Altra assegnazione auto",
    plural: "Altre assegnazioni auto",

    questions: {
      delete: "Vuoi davvero eliminare questa altra assegnazione auto?",
    },

    errors: {
      carPoolOverlapPeriod: "L'auto è già nel parco auto in questo periodo",
      carPoolOverlapPeriodWithDrivers: "L'auto ha già un conducente in questo periodo",
      assignmentOutOfSubsidiaryPeriod: "Il periodo dell'assegnazione non rientra nel periodo della consociata.",
    },
  },

  carPlannings: {
    delete: "Elimina pianificazione veicoli",
    edit: "Modifica pianificazione veicoli",
    new: "Nuova pianificazione veicoli",
    singular: "Pianificazione veicoli",
    plural: "Pianificazioni veicoli",
    versions: "Versioni della pianificazione veicoli",

    questions: {
      delete: "Vuoi davvero eliminare questa pianificazione veicoli?",
    },

    errors: {
      missingSemiramisCode:
        "Consociata senza codice di organizzazione Semiramis. Impostare il codice Semiramis nella consociata selezionata",
    },
  },

  carSubsidiaries: {
    delete: "Elimina consociata auto",
    edit: "Modifica consociata auto",
    new: "Nuova consociata auto",
    singular: "Consociata auto",
    plural: "Consociate auto",
    versions: "Versioni consociata auto",

    questions: {
      delete: "Vuoi davvero eliminare questa consociata auto?",
    },

    errors: {
      overlapPeriodCarSubsidiary: "Il periodo specificato si sovrappone con un'altra consociata.",
      overlapPeriodCarPlate: "Ci sono targhe auto che si sovrappongono con il periodo di altre consociate.",
      overlapPeriodCarDriver: "Ci sono conducenti auto che si sovrappongono con il periodo di altre consociate.",
    },
  },

  rentalCars: {
    delete: "Elimina auto a noleggio",
    edit: "Modifica auto a noleggio",
    new: "Nuova auto a noleggio",
    singular: "Auto a noleggio",
    plural: "Auto a noleggio",

    questions: {
      delete: "Vuoi davvero eliminare questa auto a noleggio?",
    },

    errors: {
      overlapPeriodCar: "Il periodo specificato si sovrappone a un altro noleggio.",
    },
  },

  userSubsidiaries: {
    delete: "Elimina filiale utente",
    edit: "Modifica filiale utente",
    new: "Nuova filiale utente",
    singular: "Filiale utente",
    plural: "Filiali utente",
    versions: "Versioni della filiale utente",

    questions: {
      delete: "Vuoi davvero eliminare questa filiale utente?",
    },
  },

  userRoles: {
    delete: "Elimina ruolo utente",
    edit: "Modifica ruolo utente",
    new: "Nuovo ruolo utente",
    singular: "Ruolo utente",
    plural: "Ruoli utente",
    versions: "Versioni del ruolo utente",

    questions: {
      delete: "Vuoi davvero eliminare questo ruolo utente?",
    },

    errors: {
      alreadyExists: "Il ruolo utente esiste già",
    },
  },

  common: {
    acceptImages: "Accetta immagini",
    acceptImagesDialog: "Le immagini caricate saranno accettate e il conducente verrà notificato via email.",
    accessNotAllowed: "Accesso non consentito",
    accessNotAllowedError: "Non hai i permessi per visualizzare questa pagina.",
    active: "Attivo",
    action: "Operazione",
    accounting: "Contabilità",
    add: "Aggiungi",
    addCustomTask: "Aggiungi task personalizzato",
    addDefaultTask: "Aggiungi task predefinito",
    addCustomCarTask: "Aggiungi task auto personalizzato",
    addDefaultCarTask: "Aggiungi task auto predefinito",
    addDueDate: "Aggiungi scadenza",
    addNew: "Aggiungi nuovo",
    addNewAssignment: "Aggiungi nuova assegnazione",
    addMileage: "Aggiungi percorrenza",
    address: "Indirizzo",
    addTask: "Aggiungi attività",
    addToCarPool: "Aggiungi al parco auto",
    addToHistory: "Aggiungi alla cronologia",
    admin: "Admin",
    administration: "Amministrazione",
    agreement: "Accordo",
    all: "Tutti",
    allowCarsToHaveMultiplePlates: "Permetti alle auto di avere più targhe",
    allowMultiplePlates: "Permetti più targhe",
    alreadyInCarPool: "Auto già nel parco auto",
    alreadyPresent: "Già presente",
    alreadyUpdated:
      "Questo record è stato aggiornato da un altro utente. Aggiorna la pagina per ottenere la versione più recente.",
    areaSalesManager: "Responsabile vendite di area",
    arrived: "Arrivata",
    arrivingSoon: "Arriverà presto",
    ascending: "Ascendente",
    assign: "Assegna",
    assignCar: "Assegna auto",
    assignHp: "Assegna nuovo telepass",
    assignNewDriver: "Assegna nuovo conducente",
    assignNewPlate: "Assegna nuova targa",
    assigned: "Assegnato",
    assignedTo: "Assegnato a",
    assignSubsidiary: "Assegna consociata",
    attachments: "Allegati",
    attachmentsHelpDialog:
      "È possibile allegare immagini e/o documenti; i file caricati saranno visibili a te e ai gestori del sistema Fleet Manager.",
    avgYears: "Ø anni",
    awaitingForApproval: "In attesa di approvazione",
    back: "Indietro",
    birthdate: "Data di nascita",
    business: "Business",
    by: "Da",
    cancel: "Annulla",
    cancelled: "Annullato",
    cancelWorkflow: "Annulla workflow",
    cancelWorkflowRequest:
      "Il workflow verrà interrotto. Tutti i caricamenti di immagini in sospeso saranno annullati. Vuoi procedere?",
    car: "Auto",
    carAssignment: "Assegnazione del veicolo",
    carCategory: "Categoria auto",
    carInCarPool: "Auto nel parco auto",
    carNotInUse: "Auto non in uso",
    carPool: "Parco auto",
    carPoolCostCenters: "Centri di costo parco auto",
    carOrdersWithNearTermText: {
      prefix: "Ci sono alcuni acquisti auto con data di arrivo vicina non ancora assegnati. Clicca ",
      linkTitle: "qui",
      suffix: " per elencarli e sistemarli.",
    },
    carReplacedRental: "Auto sostitutiva a noleggio",
    cartax: "Tassa auto",
    carVin: "Auto (Telaio)",
    categories: "Categorie",
    category: "Categoria",
    changeFlag: "Cambia bandiera",
    checkWorkflow: "Verifica workflow",
    clear: "Cancella",
    close: "Chiudi",
    closed: "Chiuso",
    awaitingDocuments: "In attesa di documenti",
    closingDate: "Data di chiusura",
    columnNotFilterable: "Questa colonna non può essere filtrata",
    filterEquals: "Uguale a",
    filterRange: "Da - A",
    filterMonth: "Mese",
    columnNotSortable: "Questa colonna non è ordinabile",
    continue: "Continua",
    contractDate: "Data contratto",
    contractDetails: "Dettagli contratto",
    cost: "Costo",
    costInputFormNet: "Costo (Netto - Valuta)",
    countDate: "Data conteggio",
    country: "Paese",
    countryIsoCode: "Codice ISO Paese",
    countryIsoCodeRequiredForAgreement:
      "La creazione di un accordo richiede che il codice ISO del paese della consociata sia impostato.",
    costCenter: "Centro di costo",
    costCenterHistory: "Storico centro di costo",
    costObject: "Oggetto di costo",
    costImport: "Importazione costi",
    costImports: "Importazioni costi",
    costGross: "Costo lordo",
    costNet: "Costo netto",
    co2: "Co2",
    create: "Crea",
    createdAt: "Creato il",
    createdBy: "Creato da",
    createDelegation: "Crea delega",
    createDelegationWithDriverSelection: "Crea delega con selezione conducente",
    createDelegationForExternal: "Crea delega per persone esterne",
    createNew: "Crea nuovo",
    currency: "Valuta",
    currentHighwayPass: "Telepass attuale",
    currentDriver: "Conducente attuale",
    currentlyInCarPool: "Questa auto è attualmente nel parco auto.",
    currentlyNotUsed: "Questa auto non è attualmente in uso.",
    currentlyAssignToDriver: "Questa auto è attualmente assegnata a un altro conducente.",
    currentPlateNumber: "Targa attuale",
    currentSubsidiary: "Consociata attuale",
    currentVersion: "Versione attuale",
    dashboard: "Dashboard",
    dataConflicts: (value: string) => `Dati in conflitto con la data ${value}`,
    dataHasBeenSavedSuccessfully: "Dati salvati con successo.",
    dataHasBeenUpdatedSuccesfully: "Dati aggiornati con successo.",
    date: "Data",
    datePicker: {
      clearButton: "Rimuovi data",
      nextMonth: "Mese successivo",
      placeholder: "Seleziona data",
      previousMonth: "Mese precedente",
      selectMonth: "Seleziona mese",
      selectYear: "Seleziona anno",
    },
    decrease: (value: number) => `Diminuisci ${value}`,
    defaultCurrency: "Valuta predefinita",
    defaultLanguage: "Lingua predefinita",
    delegation: "Delega",
    delete: "Elimina",
    deleteFilter: (filter: string) => `Elimina filtri per ${filter}`,
    deleteFilters: "Elimina filtri",
    department: "Reparto",
    departments: "Reparti",
    descending: "Discendente",
    description: "Descrizione",
    diesel: "Diesel",
    discountGross: "Sconto lordo",
    discountNet: "Sconto netto",
    distance: "Distanza",
    distances: "Distanze",
    distanceInMiles: "Distanza in miglia",
    divisionSalesManager: "Responsabile vendite di divisione",
    dkvProductCodes: "Codici prodotto DKV",
    documents: "Documenti",
    done: "Fatto",
    download: "Scarica",
    downloadFile: "Scarica file",
    dragAndDropOrUploadAnImage: "Trascina e rilascia o clicca per caricare un'immagine",
    driverAlreadyNotified: "A questo conducente è già stata inviata un'email di notifica. Vuoi inviarla di nuovo?",
    driverNotified: (on: string) => `Conducente notificato il ${on}. In attesa del caricamento delle immagini.`,
    dragAndDropOrUploadAnFile: "Trascina e rilascia o clicca per caricare un file",
    driverName: "Nome del conducente",
    driverSince: "Conducente dal",
    drivingLicenseExpirationDate: "Data scadenza patente",
    drivingLicenseText:
      "Inserendo nel sistema la data di scadenza della tua patente, riceverai automaticamente una notifica di promemoria circa 20 giorni prima della scadenza stessa. Le informazioni inserite non vengono tracciate né gestite da Fleet Management, ma sono elaborate esclusivamente dal sistema.",
    dropIt: "Rilascia",
    dueDateHelpDialog: "Inserendo una data, la scadenza verrà aggiornata con la data selezionata.",
    dueDateVisibleToUser:
      "La selezione di un utente rende la scadenza visibile sia all'utente stesso sia ai relativi manager.",
    edit: "Modifica",
    editedBy: "Modificato da",
    editNotPermitted: "La modifica non è più consentita — è passato più di un giorno dalla creazione.",
    electric: "Elettrica",
    email: "Email",
    emailSendToDriver: "Verrà inviata una notifica per email al conducente.",
    empty: "Vuoto",
    endDate: "Data fine",
    engineCapacity: "Cilindrata",
    english: "Inglese",
    englishUk: "Inglese - UK",
    englishUs: "Inglese - US",
    englishBrasil: "Inglese - Brasile",
    enteredDate: "Data inserimento",
    enterAPhoneNumber: "Inserisci un numero di telefono",
    enterValidNames: "Inserisci nomi validi.",
    error: "Errore",
    errorLoadingData: "Errore nel caricamento dei dati",
    expirationDate: "Data scadenza",
    expired: "Scaduto",
    expiringSoon: "In scadenza",
    exportExcel: "Esporta Excel",
    fieldCannotBeEmpty: "Il campo non può essere vuoto.",
    file: "File",
    fileCsv: "File CSV",
    fileNotSupported: `Il file non è supportato.`,
    fileTypeSupported: (extensions: string[]) => `Tipi di file supportati: ${extensions.join(", ")}.`,
    fileToLarge: "File troppo grande",
    fiscalPrice: "Prezzo fiscale",
    fieldContainsInvalidValueInsertBiggerOne: "Il campo contiene un valore non valido, inseriscine uno maggiore.",
    fieldContainsInvalidValueInsertSmallerOne: "Il campo contiene un valore non valido, inseriscine uno minore.",
    fieldInvalidValue: "Il campo contiene un valore non valido.",
    fieldValueInvalidFormat: "Il valore ha un formato non valido.",
    firstName: "Nome",
    flag: "Bandiera",
    french: "Francese",
    fringeBenefit: "Fringe benefit",
    from: "Da",
    fuelCard: "Carta carburante",
    fuelType: "Tipo di carburante",
    gasoline: "Benzina",
    generalData: "Dati generali",
    generateAgreement: "Genera accordo",
    genericError: "Si è verificato un errore, riprova.",
    german: "Tedesco",
    gpl: "Gpl",
    hasImportErrors: "Contiene errori di importazione",
    hidden: "Nascosto",
    hiddenText:
      "Siccome gli utenti vengono importati regolarmente dal sistema Rothoblaas, tra di essi potrebbero esserci account non necessari per il gestionale. Questo flag permette di nascondere un utente dalla gestione dei driver.",
    disableNotifications: "Disabilita notifiche",
    disableNotificationsText:
      "Se questo flag e attivo, le email di notifica automatiche non verranno inviate. Le altre email generate da azioni dell'utente continueranno a essere inviate.",
    hideArrivalNotification: "Nascondi notifica data di arrivo",
    hideToUser: "Nascondi all'utente",
    history: "Cronologia",
    hp: "CV",
    hybrid: "Ibrida",
    imagesAccepted: "Immagini accettate",
    imagesDeleted: "Immagini eliminate",
    imagesSupplied: "Immagini caricate",
    imperial: "Imperiale (miglia)",
    importInCosts: "Importa nei costi",
    import: "Importa",
    importCsv: "Importa CSV",
    importErrors: "Errori di importazione",
    importErrorsText:
      "I centri di costo vengono importati automaticamente da bValue (Provisius).<br/>Le righe sotto indicano i record che non è stato possibile importare.<br/>Verifica le date con HR e correggile sotto.",
    importDkv: "Importa DKV",
    importHighwayToll: "Importa pedaggi autostradali",
    importedInCosts: "Importato nei costi",
    increase: (value: number) => `Aumenta ${value}`,
    insert: "Inserisci",
    insurance: "Assicurazione",
    invalidDate: "Data non valida",
    invalidLenght: "Lunghezza non valida",
    invalidNumber: "Numero non valido",
    isInPool: "È nel parco auto",
    isRothoblaasUser: "È utente Rothoblaas",
    isRothoblaasUserTexts: [
      "Questo flag serve a distinguere gli utenti Rothoblaas da quelli esterni. Quando viene attivato, il sistema verifica che l'indirizzo email sia valido. In tal caso, nome e cognome vengono recuperati dalla banca dati Rothoblaas. Inoltre, non è possibile salvare un utente con un indirizzo email Rothoblaas se non esiste una corrispondenza tra gli utenti attivi.",
      "Con il flag disattivato, l'indirizzo email resta opzionale e non viene effettuata alcuna verifica sugli utenti Rothoblaas. In questo caso, invece, nome e cognome diventano obbligatori.",
    ],
    isSettled: "È saldato",
    italian: "Italiano",
    portuguese: "Portoghese",
    withErrors: "Con errori",
    withoutErrors: "Senza errori",
    itemsNotExported: "Non esportati",
    itemsForced: "Forzati",
    forcedBy: "Forzato da",
    keep: "Mantieni",
    kilometers: "Chilometri",
    language: "Lingua",
    languageCode: "Codice lingua",
    lastDriver: "Ultimo conducente",
    lastEdit: "Ultima modifica di",
    lastHighwayPass: "Ultimo telepass",
    lastMileage: "Ultima percorrenza",
    lastMileageRec: "Ultimo record percorrenza",
    lastName: "Cognome",
    lastPlate: "Ultima targa",
    lastRecord: "Ultimo record",
    lastUpdate: "Ultimo aggiornamento",
    lastUpdatedBy: "Ultimo aggiornamento da",
    latvian: "Lettone",
    leasing: "Leasing",
    lessThanDueDateRecord: "è inferiore alla data di uno dei record selezionati",
    licensePlateValidityEnd: "Fine validità targa",
    licensePlateValidityStart: "Inizio validità targa",
    lithuanian: "Lituano",
    loading: "Caricamento",
    logout: "Logout",
    lkw: "Lkw",
    lkwAccountingNumber: "Numero contabile Lkw",
    lkwAccountingNumberShort: "Lkw N. cont.",
    manageCategories: "Gestisci categorie",
    manageClaimTypes: "Gestisci tipi di sinistri",
    manageCostTypeCategories: "Gestisci categorie tipi costo",
    manageCostTypes: "Gestisci tipi costo",
    vatCodes: "Codici IVA",
    manageDefaultTasks: "Gestisci attività predefinite",
    manageDueDateTypes: "Gestisci tipi scadenza",
    manageMaintenanceTypes: "Gestisci tipi manutenzione",
    manager: "Responsabile",
    managerEmail: "Email responsabile",
    managerName: "Nome responsabile",
    metric: "Metrico (km)",
    mileage: "Percorrenza",
    mileages: "Percorrenze",
    miles: "miglia",
    missingContractDate: "Data contratto mancante",
    missingCountry: "Paese mancante",
    missingExpirationDate: "Data scadenza mancante",
    missingLeasingCompany: "Società di leasing mancante",
    missingRenewalDate:
      "Attenzione! Non è stata inserita alcuna data di rinnovo; la scadenza non verrà aggiornata e sarà semplicemente chiusa.",
    modifiedAt: "Modificato il",
    modifiedBy: "Modificato da",
    model: "Modello",
    monthYearPicker: {
      clearButton: "Rimuovi mese",
      nextYear: "Anno successivo",
      placeholder: "Seleziona mese",
      previousYear: "Anno precedente",
      selectYear: "Seleziona anno",
    },
    myArea: "La mia area",
    myCar: "La mia auto",
    myCars: "Le mie auto",
    myProfile: "Il mio profilo",
    myTeamCar: "Auto del mio team",
    myTeamCars: "Auto del mio team",
    name: "Nome",
    needsAttention: "Richiede attenzione",
    ordersWithNearArrivalDate: "Acquisti auto con arrivo imminente",
    nextNRows: (n: number) => `Prossime ${n} righe`,
    newLeasing: "Nuovo leasing",
    newPlateNumber: "Nuovo numero di targa",
    newOrder: "Nuovo acquisto",
    no: "No",
    noDriver: "Nessun conducente",
    noFileSelected: "Nessun file selezionato",
    noHighwayPasses: "Nessun telepass",
    noDueDate: "Nessuna scadenza",
    noDueDateSelected: "Nessuna scadenza selezionata",
    noItemsFound: "Nessun elemento trovato.",
    noLeasing: "Nessun leasing",
    noMilegaes: "Nessuna percorrenza",
    notes: "Note",
    noTasksToDo: "Nessuna attività da svolgere",
    notFound: "Non trovato",
    notifications: "Notifiche",
    notifyDriver: "Avvisare conducente",
    notInUse: "Non in uso",
    notPlannedPurchase: "Acquisto non pianificato",
    notRequired: "Non richiesto",
    notSettled: "Non saldato",
    number: "Numero",
    count: "Conteggio",
    open: "Aperto",
    ok: "Ok",
    on: "il",
    openingDate: "Data di apertura",
    operation: "Operazione",
    optional: "Opzionale",
    optionals: "Opzionali",
    order: "Ordine",
    orderImperativ: "Ordina",
    orderCar: "Ordina auto",
    orderDate: "Data dell'ordine",
    ordered: "Ordinato",
    overview: "Panoramica",
    overwrite: "Sovrascrivi",
    otherAssignmentType: "Parco auto / Non in uso",
    others: "Altro",
    parking: "Parcheggio",
    permissions: "Permessi",
    phoneNumber: "Numero di telefono",
    phoneNumberIsInvalid: "Il numero di telefono non è valido per questo paese",
    picture: "Immagine",
    plannedArrivalDate: "Data di arrivo prevista",
    plugInHybrid: "Ibrida plug-in",
    pkw: "Pkw",
    pkwAccountingNumber: "Numero contabile Pkw",
    pkwAccountingNumberShort: "Pkw N. cont.",
    pkwSuperior: "Pkw superiore",
    pkwSuperiorAccountingNumber: "Numero contabile Pkw superiore",
    pkwSuperiorAccountingNumberShort: "Pkw Sup. N. cont.",
    pkwUp: "Pkw Up",
    pkwUpAccountingNumber: "Numero contabile Pkw Up",
    pkwUpAccountingNumberShort: "Pkw Up N. cont.",
    positionCode: "Codice posizione",
    positionName: "Nome posizione",
    preferredLanguage: "Lingua preferita",
    preview: "Anteprima",
    previousEndDateLowerStartDate: "Inserisci una data di fine precedente maggiore della sua data di inizio.",
    previousEndDateUndefined: "Imposta una data di fine per il record precedente.",
    previousNRows: (n: number) => `Precedenti ${n} righe`,
    purchasePriceInputForm: "Prezzo d'acquisto (senza IVA - con IVA - valuta)",
    priceWithVat: "Prezzo con IVA",
    priceWithoutVat: "Prezzo senza IVA",
    pricePerUnit: "Prezzo per unità",
    private: "Privato",
    privateCar: "Auto privata",
    productCategory: "Categoria prodotto",
    productCode: "Codice prodotto",
    productType: "Tipo di prodotto",
    purchase: "Acquisto",
    purchaseDate: "Data acquisto",
    purchaseType: "Acquisto / Leasing",
    quantity: "Quantità",
    read: "Leggi",
    reAssignment: "Riassegnazione",
    recipient: "Destinatario",
    resourceNotFound: "La risorsa che stai cercando non è stata trovata.",
    responsible: "Responsabile",
    responsibleCode: "Codice responsabile",
    returned: "Restituita al leasing",
    regionSalesManager: "Responsabile vendite regionale",
    registrationDate: "Data immatricolazione",
    rejectImages: "Rifiuta immagini",
    rejected: "Respinto",
    rejectImagesForm:
      "Le immagini caricate saranno rifiutate ed eliminate. Il conducente verrà informato via email che sono richieste nuove immagini. Puoi fornire un messaggio da includere nell'email:",
    reloadData: "Ricarica dati",
    remove: "Rimuovi",
    rename: "Rinomina",
    renameDocument: "Rinomina documento",
    reopen: "Riapri",
    reopenWorkflow: "Riapri workflow",
    renewalDate: "Data di rinnovo",
    roles: "Ruoli",
    rolesAndPermissions: "Ruoli e permessi",
    salesRole: "Ruolo vendite",
    save: "Salva",
    saving: "Salvataggio",
    search: "Cerca",
    select: "Seleziona",
    selectAll: "Seleziona tutto",
    selectACountry: "Seleziona un paese",
    selectDate: "Seleziona data",
    selectFile: "Seleziona file",
    selectFlag: "Seleziona bandiera",
    semiramisOrganizationCode: "Codice organizzazione Semiramis",
    sendDelegation: "Invia delega",
    send: "Invia",
    sendEmail: "Invia email",
    setAsDone: "Imposta come completato",
    inProgress: "In lavorazione",
    setAsNotRequired: "Imposta come non richiesto",
    setAsTodo: "Imposta come da fare",
    setIsoCode: "Imposta codice ISO",
    setNotInUse: "Imposta come non in uso",
    setSubsidiaryIsoCode: "Imposta codice ISO consociata",
    settings: "Impostazioni",
    settled: "Saldato",
    setToday: "Imposta oggi",
    showArrivalNotification: "Mostra notifica data di arrivo",
    showToUser: "Mostra all'utente",
    sold: "Venduta",
    someCostCenterPeriodsOverlap: "Alcuni periodi dei centri di costo si sovrappongono.",
    sortAscending: "Ordina ascendente",
    sortDescending: "Ordina discendente",
    spanish: "Spagnolo",
    startDate: "Data inizio",
    startDateBeforeEndDatePrevRecord: "Inserisci una data di inizio successiva alla fine del record precedente.",
    startDateEqualEndDate: "Inserisci una data di inizio precedente alla data di fine.",
    startDateEqualPrevEndDate: "Data di inizio uguale alla data di fine del record precedente",
    startDistance: "Distanza iniziale",
    state: "Stato",
    serviceFeeNet: "Tariffa servizio netta",
    serviceFeeGross: "Tariffa servizio lorda",
    since: "Da",
    soldDate: "Data di vendita",
    subsidiaryRequiredForAgreement: "La creazione dell'accordo richiede l'associazione dell'auto a una consociata.",
    subsidiaryRequiredForDelegation: "La creazione di una delega richiede l'associazione dell'auto a una consociata.",
    subsidiaryHasCustomTasks: "La consociata ha attività personalizzate",
    subsidiaryUsesDefaultTasks: "La consociata utilizza attività predefinite",
    tasks: "Attività",
    taskCancelled: "Attività annullata - nessuna azione richiesta",
    teamCar: "Auto del team",
    teamMembers: "Membri del team",
    technicalSale: "Tecnico commerciale",
    telepass: "Telepass",
    testEnvironment: "Ambiente di test",
    time: "Ora",
    to: "A",
    toApprove: "Da approvare",
    toAssign: "Da assegnare",
    todo: "Da fare",
    tolls: "Pedaggi",
    toOrder: "Da ordinare",
    total: "Totale",
    type: "Tipo",
    typeOfUse: "Tipo di utilizzo",
    unassigned: "Non assegnato",
    unit: "Unità",
    until: "Fino a",
    userCostCenters: "Centri di costo utente",
    userCostCentersHasImportErrorsText: {
      prefix: "L'importazione dei centri di costo utenti da bValue (Provisius) contiene errori. Clicca",
      linkTitle: "qui",
      suffix: "per elencarli e sistemarli.",
    },
    usersWithImportErrors: "Utenti con errori di importazione",
    userWithoutCostCenter: "Utente senza centro di costo",
    update: "Aggiorna",
    uploadedAt: "Caricato il",
    uploadedBy: "Caricato da",
    uploadImages: "Carica immagini",
    uploadImagesRequired: "Caricare le immagini richieste",
    vat: "IVA",
    vatCode: "Codice IVA",
    vatDeductionCode: "Codice detrazione IVA",
    vatServiceCode: "Codice servizio IVA",
    vehicleIdentificationNumber: "Numero identificazione veicolo",
    version: "Versione",
    versions: "Versioni",
    versionNumber: "Numero versione",
    viewImages: "Visualizza immagini",
    visibleToUser: "Visibile all'utente",
    visibleToUserInfo:
      "Questo campo consente di selezionare un utente con cui condividere la data di scadenza. Per impostazione predefinita, è disponibile per la selezione l'utente attualmente assegnato al veicolo. Se la data di scadenza è stata precedentemente condivisa con un altro utente, saranno selezionabili sia l'utente attualmente assegnato sia l'utente con cui era stata condivisa in precedenza.",
    view: "Mostra",
    waitingForImageApproval: "In attesa di approvazione delle immagini",
    waitingUser: "In attesa dell'utente",
    warningCloseEntities: (from: string, to: string) =>
      `Il periodo definito (${from}-${to}) è in conflitto con altri record. Confermando, ${to} verrà applicata come data di fine per i record elencati sopra.`,
    warningReOpenEntities: (from: string, to: string) =>
      `Il periodo selezionato (${from}-${to}) è in conflitto con altri record. Seleziona le caselle dei record che vuoi trasferire alla nuova società. Confermando, ${to} verrà applicata come data di fine per i record selezionati e come data di inizio per quelli nuovi.`,
    when: "Quando",
    workflowCancelled: "Workflow annullato. Puoi riaprirlo con il pulsante qui sotto.",
    workflowImages: "Immagini del workflow",
    yes: "Sì",
    year: "Anno",

    endDateCantMatchStartDate: "La data di fine non può coincidere con la data di inizio",
    endDateBeforeStartDate: "La data di fine non può precedere la data di inizio",
    endDateAfterCurrentAssignmentStartDate:
      "La data di fine non può essere successiva alla data di inizio dell'assegnazione corrente",
    startDateFallsInCurrentAssignmentPeriod: "La data di inizio rientra nel periodo dell'assegnazione corrente",
    endDateFallsInCurrentAssignmentPeriod: "La data di fine rientra nel periodo dell'assegnazione corrente",
    endDateAfterStartDateNextRec: "Inserisci una data di fine precedente alla data di inizio del record successivo.",
    endDateEqualNextStartDate: "Data di fine uguale alla data di inizio del record successivo",
  },
};
export default it;
